import { IResult, IScoreItem } from "../Interfaces";

const EXPERTISE_DOMAIN_INDEX = 6;
const MAJOR_DOMAIN_INDEX = 7;
const USER_SCORE_INDEX = 9;
const MAX_VALUE_QUESTION = 4;
const INITIAL_SCORE_VALUE = 0;

export class Score {
  result: IResult[] = [
    {
      name: "",
      maxScore: 0,
      globalScore: 0,
      scoreItems: [
        {
          name: "",
          userScore: 0,
          totalQuestionNumber: 0,
        },
      ],
    },
  ];

  constructor(_rawData: string[]) {
    const rawData = _rawData.map((item) => item[EXPERTISE_DOMAIN_INDEX]);
    const uniqueDomain = new Set(rawData);

   const userResult = Array.from(uniqueDomain).map((item: string) => {
      //filtre sur charque domaine
      const eachExpertiseDomain = _rawData.filter(
        (answer) => answer[EXPERTISE_DOMAIN_INDEX] === item
      );

      //calcul score
      const itemScore = eachExpertiseDomain.reduce(
        (accumulator, currentValue) =>
          accumulator + parseInt(currentValue[USER_SCORE_INDEX]),
        INITIAL_SCORE_VALUE
      );

      return {
        name: item,
        maxScore:eachExpertiseDomain.length * MAX_VALUE_QUESTION,
        globalScore :itemScore,
        scoreItems :this.getScorePerMajorDomain(eachExpertiseDomain),
      };
    });
    this.result = userResult
  }

  getScorePerMajorDomain = (expertiseDomain: string[]): IScoreItem[] => {
    const majorDomain = expertiseDomain.map(
      (item: string) => item[MAJOR_DOMAIN_INDEX]
    );
    let uniqueDomain = new Set(majorDomain);

    const scoreItems = Array.from(uniqueDomain).map((item: string) => {
      //filter by major domain
      const totalQuestions = expertiseDomain.filter(
        (answer) => answer[7] === item
      );

      //calculate the userScore per major domain
      const userScore = totalQuestions.reduce(
        (accumulator, currentValue) =>
          accumulator + parseInt(currentValue[USER_SCORE_INDEX]),
        INITIAL_SCORE_VALUE
      );

      return {
        name: item,
        userScore: userScore,
        totalQuestionNumber: totalQuestions.length,
      };
    });
    return scoreItems;
  };
}
